import React from 'react';
import styled from 'styled-components';

export interface FormLayoutProps
  extends React.AllHTMLAttributes<HTMLFormElement> {}

const StyledFormLayout = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormLayoutComponent = ({
  onSubmit,
  noValidate = false,
  children,
}: FormLayoutProps) => {
  return (
    <StyledFormLayout onSubmit={onSubmit} noValidate={noValidate}>
      {children}
    </StyledFormLayout>
  );
};

export default FormLayoutComponent;
